<igo-list [navigation]="false">
  @for (catalog of getCatalogs() | async; track catalog) {
    <igo-catalog-library-item
      igoListItem
      color="accent"
      [map]="map()"
      [catalog]="catalog"
      (catalogRemove)="onCatalogRemove(catalog)"
      (select)="onCatalogSelect(catalog)"
    />
  }
</igo-list>

@if (addCatalogAllowed()) {
  <div class="btnAddCatalog">
    <button
      matButton="elevated"
      [matTooltip]="'igo.geo.catalog.library.addBtn' | translate"
      matTooltipPosition="above"
      color="primary"
      (click)="addCatalogDialog()"
    >
      {{ 'igo.geo.catalog.library.addBtn' | translate }}
      <mat-icon>library_add</mat-icon>
    </button>
  </div>
}
